import React from "react";
import { Link, LinkProps, To } from "react-router-dom";

interface DisableableLinkProps extends LinkProps {
  isDisabled?: boolean;
  to: To;
  children: React.ReactNode;
}

const Button: React.FC<DisableableLinkProps> = ({ isDisabled, to, children, ...rest }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    if (isDisabled) {
      event.preventDefault();
    }
  };

  // Optional: Add custom style or classes based on the disabled state
  const linkStyle: React.CSSProperties = isDisabled
    ? {
        color: "#fff", // Define the color as a string
        pointerEvents: "none", // Correct usage for pointer-events
        cursor: "not-allowed", // Correct usage for cursor
        backgroundColor: "#ebebeb",
      }
    : {};

  return (
    <Link to={to} onClick={handleClick} style={linkStyle} {...rest}>
      {children}
    </Link>
  );
};

export default Button;
